import moment from 'moment';
import React from 'react';
// Coupon or Voucher follow ups/early bird deadline - Set 2
const ElevenStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    conference_location,
    conference_from_date,
    conference_to_date,
    coupon_code,
    discount_amount,
    registration_link,
    your_name,
    contact_details
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name}` : `Hi [Recipient's Name],`}</p>
      <p>
        We’re excited to offer you an exclusive opportunity to register for {' '}
        <strong>
        {conference_short_name
          ? conference_short_name
          : `[Conference short Name]`}</strong>
        , a CPD-accredited event taking place on{' '}
        <strong>
        {conference_from_date && conference_to_date
          ? `${conference_from_date} - ${conference_to_date}`
          : `[Conference from and to Date]`}</strong>{' '}
        at <strong>{conference_location ? conference_location : `[Conference Venue]`}</strong>.
      </p>
      <p>
        Use the coupon code <strong>{coupon_code ? coupon_code : `[Coupon Code]`}</strong> to
        enjoy a <strong>{discount_amount ? discount_amount : `[Discount Amount]`}</strong>{' '}
        discount on your registration fee!
      </p>

      <p>
        Benefits of Attending:
        <br />✅ <strong>CPD Accreditation:</strong> Earn a globally recognized
        CPD certification to enhance your professional credentials.
        <br />✅ <strong>Global Networking:</strong> Connect with top
        researchers, academicians, and professionals from around the world.
        <br />✅ <strong>Publication Opportunities:</strong> Get your work
        published in Scopus, Web of Science, or SCI-indexed journals, ensuring
        maximum academic visibility.
        <br />✅ <strong>Innovative Discussions:</strong> Engage in sessions
        aligned with United Nations SDGs and the latest global research trends.
      </p>
      <p>
        {registration_link ? (
          <>
            👉 Register Now:{' '}
            <a
              href={registration_link}
              target="_blank"
              // rel="noopener noreferrer"
            >
              Click Here
            </a>
          </>
        ) : (
          '👉 Register Here: [Registration Link]'
        )}
      </p>
      <p>
        Don’t miss this chance to grow your career and make a lasting impact.
        Let me know if you have any questions or need assistance with
        registration!
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default ElevenStepTemplate;
